import React from 'react';
import { SectionReveal } from './ui/SectionReveal';
import { ArrowRight } from 'lucide-react';
export function Insights() {
  const articles = [{
    title: 'Why Developer Productivity Is the Next Competitive Battleground',
    outlet: 'Forbes',
    readTime: '7 min read'
  }, {
    title: 'DORA Metrics in Practice: Moving Beyond the Vanity Dashboard',
    outlet: 'Forbes Tech Council',
    readTime: '6 min read'
  }, {
    title: 'How Engineering Leaders Can Turn Data Into Strategic Decisions',
    outlet: 'TechCrunch',
    readTime: '8 min read'
  }, {
    title: 'The Real Cost of Slow Code Reviews on Enterprise Teams',
    outlet: 'Fortune',
    readTime: '5 min read'
  }, {
    title: 'Restructuring Your Engineering Org for the Next Stage of Growth',
    outlet: 'Forbes',
    readTime: '9 min read'
  }, {
    title: 'What 500+ Engineering Teams Taught Me About Shipping Faster',
    outlet: 'Entrepreneur',
    readTime: '7 min read'
  }, {
    title: 'Measuring Engineering Without Surveilling Engineers',
    outlet: 'Forbes Tech Council',
    readTime: '6 min read'
  }, {
    title: 'How to Hire (and Keep) Senior Engineers in a Tight Market',
    outlet: 'TechCrunch',
    readTime: '8 min read'
  }, {
    title: 'From Founder to CEO: Scaling Yourself as Your Company Grows',
    outlet: 'Entrepreneur',
    readTime: '7 min read'
  }];
  return <section id="insights" className="py-24 md:py-32" data-id="element-189">
      <div className="container mx-auto px-6 md:px-12" data-id="element-190">
        <SectionReveal data-id="element-191">
          <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16" data-id="element-192">
            <div className="max-w-2xl" data-id="element-193">
              <h2 className="font-serif text-4xl md:text-5xl mb-6" data-id="element-194">
                Selected Writing
              </h2>
              <p className="text-lg text-secondary" data-id="element-195">
                Articles by Alex Circei on engineering leadership, developer
                productivity, and scaling teams — published in Forbes,
                TechCrunch, Fortune, and Entrepreneur.
              </p>
            </div>
            <a href="#" className="inline-flex items-center text-sm font-medium text-accent hover:text-accent-hover transition-colors group shrink-0" data-id="element-196">
              View all articles
              <ArrowRight className="ml-2 w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-197" />
            </a>
          </div>
        </SectionReveal>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-198">
          {articles.map((article, index) => <SectionReveal key={index} delay={index % 3 * 0.1} data-id="element-199">
              <a href="#" className="block group h-full" data-id="element-200">
                <div className="p-8 rounded-2xl bg-surface border border-border group-hover:border-accent/30 transition-colors h-full flex flex-col" data-id="element-201">
                  <div className="flex items-center gap-3 text-xs text-muted uppercase tracking-wider mb-4" data-id="element-202">
                    <span className="text-accent font-medium" data-id="element-203">
                      {article.outlet}
                    </span>
                    <span data-id="element-204">•</span>
                    <span data-id="element-205">{article.readTime}</span>
                  </div>
                  <h3 className="text-xl font-medium mb-4 group-hover:text-accent transition-colors leading-snug" data-id="element-206">
                    {article.title}
                  </h3>
                  <div className="mt-auto pt-6" data-id="element-207">
                    <span className="text-sm text-secondary flex items-center group-hover:text-primary transition-colors" data-id="element-208">
                      Read article{' '}
                      <ArrowRight className="ml-2 w-4 h-4 opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all" data-id="element-209" />
                    </span>
                  </div>
                </div>
              </a>
            </SectionReveal>)}
        </div>
      </div>
    </section>;
}